export const inHousePackageQueryKey = {
  all: ['in-house-packages'] as const,
  packages: () => [...inHousePackageQueryKey.all, 'list'] as const,
  options: () => [...inHousePackageQueryKey.all, 'options'] as const,
  patterns: (packageId: string) => [...inHousePackageQueryKey.all, 'patterns', packageId] as const,
  instances: (patternId: string, options?: {
    page?: number;
    pageSize?: number;
    targetId?: string;
  }) => [...inHousePackageQueryKey.all, 'instances-with-free-form-columns', patternId, options?.page ?? 1, options?.pageSize ?? 100, options?.targetId] as const,
  applicationInstances: (patternId: string, options?: {
    page?: number;
    pageSize?: number;
    targetId?: string;
  }) => [...inHousePackageQueryKey.all, 'application-instances', patternId, options?.page ?? 1, options?.pageSize ?? 100, options?.targetId] as const,
  taskCountInProgress: (packageId: string, patternId: string) => [...inHousePackageQueryKey.all, 'task-count-in-progress', packageId, patternId] as const,
  confirmationRows: (patternId: string, options?: {
    page?: number;
    pageSize?: number;
    targetId?: string;
    tagId?: string;
  }) => [...inHousePackageQueryKey.all, 'confirmation-rows', patternId, options?.page ?? 1, options?.pageSize ?? 100, options?.targetId, options?.tagId] as const
} as const;